import { createContext, useContext } from "react";
import { RefObject } from 'react';
import { ReactFlowInstance, FitViewOptions } from "reactflow";

interface CanvasContextType {
  onAddDestination?: () => void;
  reactFlowWrapper: RefObject<HTMLDivElement>;
  reactFlowInstance?: ReactFlowInstance;
  fitView?: (options?: FitViewOptions) => void;
}

export const CanvasContext = createContext<CanvasContextType | undefined>(undefined);

export function useCanvasContext() {
  const context = useContext(CanvasContext);
  if (!context) {
    throw new Error("useCanvasContext must be used within a CanvasProvider");
  }
  return context;
}
